import MapMenu from '~/components/mapContent/menu/mapMenu'
import ViewSelect, { EditSpaceToolProps } from '~/components/mapContent/viewSelect'
import { Layer } from '~/packages/general/variable/spaceTime.types'
import { VariableAndOptionalResult } from '~/packages/general/variable/variables.typing'
import styled from 'styled-components'
import { ReportWithLayer } from '~/components/mapContent/modals/reports/reports.types'

import { attributionMarginLeftPx } from './map/map'
import { MapType } from './map/mapContext'
import { Map3DOption } from './mapContent/menu/mapMenu.types'

const WrapperBottomButtons = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: ${attributionMarginLeftPx}px;
  left: 0;

  display: flex;
  justify-content: space-between;
  align-items: end;

  gap: ${({ theme }) => theme.padding(1)};
  padding-bottom: ${({ theme }) => theme.padding(1)};
  pointer-events: none;

  > * {
    pointer-events: all;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    flex-direction: column;
    justify-content: end;
    align-items: start;
  }
`

type BaseControlsProps = {
  layers: Layer[]
  baseLayers: Layer[]
  setBaseLayers: React.Dispatch<React.SetStateAction<Layer[]>>
  map3DOption: Map3DOption | undefined
  setMap3DOption: React.Dispatch<React.SetStateAction<Map3DOption | undefined>>
  mapType: MapType | undefined
  setMapType: React.Dispatch<React.SetStateAction<MapType | undefined>>
  variables: VariableAndOptionalResult[]
  children: React.ReactNode
  legendComponent?: React.ReactNode
  editProps?: EditSpaceToolProps
  canAddLayer?: boolean
  isHighResolutionSpace?: boolean
  onChangeReport?: (report: ReportWithLayer | null) => void
}

export const MainMenuControls = ({
  layers,
  baseLayers,
  setBaseLayers,
  map3DOption,
  setMap3DOption,
  mapType,
  setMapType,
  variables,
  editProps,
  children,
  canAddLayer = false,
  legendComponent,
  isHighResolutionSpace = false,
  onChangeReport,
}: BaseControlsProps) => {
  return (
    <>
      <MapMenu
        onChangeMapType={setMapType}
        mapType={mapType!}
        onChangeMap3DOption={setMap3DOption}
        map3DOption={map3DOption!}
        layers={layers}
        onChangeLayers={setBaseLayers}
        variables={variables}
        canAddLayer={canAddLayer}
      >
        {legendComponent}
      </MapMenu>
      <ViewSelect
        baseLayers={baseLayers}
        layers={layers}
        onChangeLayers={setBaseLayers}
        variables={variables}
        editProps={editProps}
        isHighResolutionSpace={isHighResolutionSpace}
        onChangeReport={onChangeReport}
      />
      <WrapperBottomButtons>{children}</WrapperBottomButtons>
    </>
  )
}
